/* eslint-disable curly */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/type-annotation-spacing */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable no-trailing-spaces */
import { Component, OnInit } from '@angular/core';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { AlertController, ModalController, NavController, Platform } from '@ionic/angular';

import { GlobalVariable } from '../global';
import { LocalStorageService } from '../services/core/local-storage.service';
import { UserApiService } from '../services/user-api.service';
import { SetupProfilePage } from '../setup-profile/setup-profile.page';
import { UserLocationPage } from '../user-location/user-location.page';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
  customerData: string;
  LastName: string;
  FirstName: string;
  Email: string;
  Birthday: string;
  Anniversary: string;
  DateJoined: string;
  CustomerType: string;
  ProfileComplete: string;
  PhoneVerified: string;
  Phone: string;
  BusinessId: string;
  deliveryAddress=[];
  paymentMethods=[];
  isLoggedIn: boolean=false;
  constructor(
    public  localStorageService: LocalStorageService,
    private alertController: AlertController,
 
    private modalController:ModalController,
    public globals:GlobalVariable,
    public server:UserApiService,
    public nativeStorage:NativeStorage,
    public navCTRL:NavController,
    public platform:Platform


  ) {}

  ngOnInit() {}
  ionViewWillEnter() {
    let login = JSON.parse(this.localStorageService.getLogin('isLogin'))
    if(login!=null){
      this.globals.isloggedIn=login;
      this.isLoggedIn=true
      // console.log('LoggedIn',this.isLoginIn)
    }
    this.getCustomerDataFromLocal();
    this.getDelAddress();
    this.getSavedCards();
  }
  getDelAddress() {
  let res= localStorage.getItem('DeliveryAddress')
      if (res != null && res!='null') {
        console.log(this.deliveryAddress);
        this.deliveryAddress = JSON.parse(res)
        console.log(res);
      }
      
 
  }
  getSavedCards(){
    let tempArray=[]
    let response=localStorage.getItem('paymentmethods')
    console.log('payment methods',response);
    
    tempArray=JSON.parse(response)
    console.log('from local storage',tempArray)
    if(tempArray!=null){
      this.paymentMethods=tempArray;
    }
}

maskNumber(cardNumber: string): string {
  if (cardNumber.length <= 8) return cardNumber;
  const visibleStart = cardNumber.slice(0, 4);
  const visibleEnd = cardNumber.slice(-4);
  const maskedPart = '*'.repeat(cardNumber.length - 8);
  return `${visibleStart}${maskedPart}${visibleEnd}`;
}

  getCustomerDataFromLocal() {
    this.FirstName = this.localStorageService.getFirstName('FirstName');
    this.LastName = this.localStorageService.getLastName('LastName');
    this.Email = this.localStorageService.getEmail('Email');
    this.Birthday = this.localStorageService.getBirthday('Birthday');
    this.Anniversary = this.localStorageService.getAnniversary('Anniversary');
    this.DateJoined = this.localStorageService.getDateJoined('DateJoined');
    
    this.CustomerType =
      this.localStorageService.getCustomerType('CustomerType');
    this.ProfileComplete =
      this.localStorageService.getProfileComplete('ProfileComplete');
    this.PhoneVerified =
      this.localStorageService.getPhoneVerified('PhoneVerified');
    this.Phone = this.localStorageService.getPhone('Phone');
    this.BusinessId = this.localStorageService.getBusinessId('BusinessId');
  }
  async addNewAddress() { //not using this func
    const alert = await this.alertController.create({
      header: 'Add new Address',
      subHeader: 'You can add upto 4',
      animated: true,
      backdropDismiss: false,
      cssClass: 'add_new_address_ALERT',
      inputs: [
        {
          name: 'deliveryAddress',
          type: 'text',
          placeholder: 'Enter New Delivery Address',
          min: 5,
          handler: (input) => {
          },
        },
        {
          name: 'addressType',
          type: 'text',
          placeholder: 'Address Name (Optional)',
          // value: 'value2',
          handler: () => {
            // console.log(name);
          },
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          },
        },
        {
          text: 'Add',
          handler: async (data = {}) => {
            console.log(data.deliveryAddress);
            console.log(data.addressType);
            if (this.deliveryAddress.length < 4) {
              this.deliveryAddress.push(data);
              console.log(this.deliveryAddress);
              localStorage.setItem('DeliveryAddress', JSON.stringify(this.deliveryAddress))
            } else {
              const alert2 = await this.alertController.create({
                subHeader: 'Too many addresses',
                message:
                  'You cannot add more address.try deleting old address first<br>To delete just swipe the address right to left.',
                buttons: ['OK'],
              });
              await alert2.present();
            }
          },
        },
      ],
    });
    await alert.present();
  }
  async addAddress(){
 
      const modal = await this.modalController.create({
      component: UserLocationPage,
      componentProps: { saveAdress: true },
      cssClass:'delivery_modal',
      mode:'ios',
  
      });
    
      await modal.present();
      modal.onDidDismiss().then(res=>{
        if(!res.data){
          this.globals.OrderType='pickup';
        }
      })
    
  }
  // editAddress(address){

  // }

  removeAddress(address) {
    console.log(address);
    this.deliveryAddress.forEach((item, index) => {
      if (item === address) this.deliveryAddress.splice(index, 1);
      localStorage.setItem(
        'DeliveryAddress',
        JSON.stringify(this.deliveryAddress)
      ); //update
    
    });
  }
  async update(){
    const modal=await this.modalController.create({
      component:SetupProfilePage,
      // breakpoints:[0,0.8,1],
      initialBreakpoint:0.7,
      backdropDismiss:false,

      
    })
await modal.present()
modal.onDidDismiss().then(res=>{
  console.log(res)
  if(res.data){
  this.FirstName=res.data.data.firstname;
  this.LastName=res.data.data.lastname;
  }
})
}
  deleteProfile(){
    this.globals.loader()
    this.server.deleteProfile().subscribe(res=>{
      console.log(res);
      this.globals.dismiss()

      if(res.success==true){
        this.globals.presentToast('Account deleted','middle');
        this.signOut();

      }
      else{
        this.globals.presentToast('failed to delete','middle');

      }

    },err=>{
      this.globals.dismiss();
      this.globals.presentToast('Network error')

    })
  }
  signOut() {
    let branch= localStorage.getItem('activeBranchid');
    let kiosk=JSON.parse(localStorage.getItem('kiosk'))
    console.log('kioskfromlocal',kiosk)
    if(kiosk!=null){
        this.globals.kiosk_flag=kiosk;}
   
      this.isLoggedIn = false;
      
      this.localStorageService.clearAll();
      this.localStorageService.setTour('Tour', JSON.stringify(true));
    localStorage.setItem('kiosk',JSON.stringify(this.globals.kiosk_flag));
    localStorage.removeItem('isLogin');

      this.nativeStorage.clear();
      this.globals.itemsInCart=[];
      this.globals.isloggedIn = false;
      localStorage.setItem('activeBranchid',branch);
      this.navCTRL.navigateRoot('/tabs/tabs/home');
    

  }
  async deleteConfirm() {
    const alert = await this.alertController.create({
      header: 'Delete Account',
      message: "Your're about to delete your account, All your points and rewards will be gone.",
      mode:'ios',

      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Delete',
          handler: () => {
            console.log('Confirm Okay');
           this.deleteProfile();

          }
        }
      ]
    });
  
    await alert.present();
  }


  
}
